module.exports = __webpack_public_path__ + "static/media/tiktok.0fe55bef.svg";